import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=03bb1a09&scoped=true&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LanguageSwitcher.vue?vue&type=style&index=1&id=03bb1a09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb1a09",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bb1a09')) {
      api.createRecord('03bb1a09', component.options)
    } else {
      api.reload('03bb1a09', component.options)
    }
    module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=03bb1a09&scoped=true&", function () {
      api.rerender('03bb1a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LanguageSwitcher.vue"
export default component.exports